// Centralised data-testid constants for the Four Hundred Club tracker
export const HOME = {
  emergentLink: "emergent-link",
};

export const APP_IDS = {
  yearSelect: "year-select",
  statsTotal: "stat-total",
  statsSold: "stat-sold",
  statsReserved: "stat-reserved",
  statsRevenue: "stat-revenue",

  tabGrid: "tab-grid",
  tabSell: "tab-sell",
  tabSellers: "tab-sellers",
  tabLog: "tab-log",
  tabReport: "tab-report",

  filterAll: "filter-all",
  filterAvailable: "filter-available",
  filterReserved: "filter-reserved",
  filterSold: "filter-sold",

  ticketCell: (n) => `ticket-cell-${n}`,

  modal: "ticket-modal",
  modalClose: "ticket-modal-close",
  modalRelease: "ticket-modal-release",
  modalMarkSold: "ticket-modal-mark-sold",

  sellTicketNumber: "sell-ticket-number",
  sellBuyerName: "sell-buyer-name",
  sellBuyerPhone: "sell-buyer-phone",
  sellSeller: "sell-seller",
  sellAction: "sell-action",
  sellRecord: "sell-record",
  sellClear: "sell-clear",
  sellPreview: "sell-preview",
  releaseTicketNumber: "release-ticket-number",
  releaseBtn: "release-btn",

  sellerName: "seller-name-input",
  sellerPhone: "seller-phone-input",
  addSellerBtn: "add-seller-btn",
  removeSellerBtn: (id) => `remove-seller-${id}`,

  logSearch: "log-search",
  logEntry: (i) => `log-entry-${i}`,

  exportCsv: "export-csv",
};
